import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as actions from './actions';
import { DashboardService } from '../../services/dashboard.service';
import { AlertService } from '../../services/alert.service';
import { switchMap, catchError, map } from 'rxjs/operators';

@Injectable()
export class DashboardEffects {
  constructor(
    protected store: Store<AppState>,
    protected service: DashboardService,
    protected action$: Actions,
    private alertService: AlertService
  ) { }

  GetDashboard$ = createEffect(() => this.action$.pipe(
    ofType<actions.GetDashboardListAction>(actions.GET_DASHBOARD_LIST),
    switchMap(action => this.service.getItems(action.pgNum, action.pgSize).pipe(
      map((result) => new actions.GetDashboardListActionSuccess(result)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.GetDashboardListActionError(error));
      })))));
}
